import { render, staticRenderFns } from "./Digit.vue?vue&type=template&id=3c3beaac&scoped=true&"
import script from "./Digit.vue?vue&type=script&lang=js&"
export * from "./Digit.vue?vue&type=script&lang=js&"
import style0 from "./Digit.vue?vue&type=style&index=0&id=3c3beaac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3beaac",
  null
  
)

export default component.exports